export const AddUserIconV2 = (props) => (
  <svg fill="none" height={18} viewBox="0 0 18 18" width={18} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.5 6.75V9M13.5 9V11.25M13.5 9H15.75M13.5 9H11.25M9.75 5.25C9.75 6.04565 9.43393 6.80871 8.87132 7.37132C8.30871 7.93393 7.54565 8.25 6.75 8.25C5.95435 8.25 5.19129 7.93393 4.62868 7.37132C4.06607 6.80871 3.75 6.04565 3.75 5.25C3.75 4.45435 4.06607 3.69129 4.62868 3.12868C5.19129 2.56607 5.95435 2.25 6.75 2.25C7.54565 2.25 8.30871 2.56607 8.87132 3.12868C9.43393 3.69129 9.75 4.45435 9.75 5.25ZM2.25 15C2.25 13.8065 2.72411 12.6619 3.56802 11.818C4.41193 10.9741 5.55653 10.5 6.75 10.5C7.94347 10.5 9.08807 10.9741 9.93198 11.818C10.7759 12.6619 11.25 13.8065 11.25 15V15.75H2.25V15Z"
      stroke="#ABB0B9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
